module.exports = __webpack_public_path__ + "static/d295aca502535882a99f93645bda62bd_L-08781f81eb38d2d1c1092ceed466e8a0.webp";